import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment/moment';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import classes from './bottom_tab.module.scss';
import { ReactComponent as CheckIcon } from '../../../../../assets/icons/check.svg';
import Pagination from '../../../../_common/Pagination/Pagination';
import Loader from '../../../../_common/Loader/Loader';
import { getPersonsChangelog } from '../../../../../store/actions/possiblePersons';

function Changelog() {
  const { personsId } = useParams();
  const dispatch = useDispatch();
  const changelogData = useSelector((store) => store.possiblePersons.changelogData);
  const changelogCurrentPage = useSelector((store) => store.possiblePersons.changelogCurrentPage);
  const changelogPageCount = useSelector((store) => store.possiblePersons.changelogPageCount);
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await dispatch(getPersonsChangelog({ id: personsId, page: changelogCurrentPage }));

      setLoading(false);
    })();
  }, []);

  const changePage = async (path, page) => {
    setPageLoading(true);
    await dispatch(getPersonsChangelog({ id: personsId, [path]: page }));
    setPageLoading(false);
  };

  return (
    <div className={classes.changelog_wrapper}>
      {pageLoading && <Loader />}

      {loading
        ? <div className={classes.changelog_loader}><Loader /></div>

        : (!changelogData.length && !loading

          ? <div className={classes.notResult}>No Data Found</div>

          : changelogData.map((c) => (
            <div className={classes.changelog} key={c.id}>
              <div className={classes.changelog_icon}>
                <CheckIcon />
              </div>

              <div className={classes.changelog_text}>
                <p className={classes.changelog_title}>{_.upperFirst(c.type)}</p>

                <p className={classes.changelog_description}>{c.description}</p>

                <div className={classes.changelog_info}>
                  <p>
                    {moment(c.updatedAt)
                      .calendar()}
                  </p>

                  <p>{`Responsible person: ${c.creator.name}`}</p>
                </div>
              </div>
            </div>
          ))

        )}

      <div className={classes.pagination}>
        <Pagination
          page={+changelogCurrentPage - 1}
          totalPage={+changelogPageCount}
          onChange={changePage}
          showLimit
        />
      </div>
    </div>
  );
}

export default Changelog;
